import React from "react";
import { connect } from "react-redux";

import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogHeaderContainer: {
    display: "flex",
    paddingRight: 30,
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: 30,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
  },
  link: {
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
  list: {
    paddingLeft: 20,
    marginBottom: 0,
  },
  listItem: {
    paddingBottom: theme.shape.padding,
  },
  close: {
    cursor: "pointer",
  },
}));

export const RunTestDialog = (props) => {
  const classes = useStyles();

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <div className={classes.dialogHeaderContainer}>
        <DialogTitle>Run a test</DialogTitle>
        <CloseIcon className={classes.close} onClick={props.onClose} />
      </div>
      <DialogContent className={classes.dialogContent}>
        <p className={classes.title}>Microsoft 365 email forwarding test</p>
        <p>
          Blumira will generate a finding anytime an email forwarding rule is
          set up for an external domain. Following the steps below should
          generate a new finding and is a quick and easy way to ensure Blumira
          is working.
        </p>
        <ol className={classes.list}>
          <li className={classes.listItem} style={{ paddingTop: 10 }}>
            Log in to{" "}
            <a
              href={"https://outlook.office365.com/mail/"}
              target={"_blank"}
              rel={"noopener noreferrer"}
              className={classes.link}
            >
              https://outlook.office365.com/mail/ <OpenInNewIcon />
            </a>
          </li>
          <li className={classes.listItem}>
            Right click any email, go to “Advanced actions” and select “Create
            rule”
          </li>
          <li className={classes.listItem}>Click “More options”</li>
          <li className={classes.listItem}>
            Click the “Add an action” drop menu and select “Forward to”
          </li>
          <li className={classes.listItem}>
            Enter any external email address and click “Save”
          </li>
        </ol>
        <p style={{ paddingTop: 12 }}>
          A new finding and email notification should be generated within a few
          minutes.
        </p>
      </DialogContent>
    </Dialog>
  );
};

RunTestDialog.propTypes = {};

RunTestDialog.defaultProps = {};

export default connect(null, null)(RunTestDialog);
